import { formatDate } from '@/shared/utils'

/**
 * Tiempo relativo corto en español a partir de un epoch (ms). Más de una semana
 * cae a fecha corta ("25 jul 2026"). `now` es inyectable para tests.
 */
export function relativeTime(timestamp: number, now: number = Date.now()): string {
  const diffMin = Math.max(0, Math.floor((now - timestamp) / 60_000))
  if (diffMin < 1) return 'Ahora'
  if (diffMin < 60) return `Hace ${diffMin} min`

  const diffHours = Math.floor(diffMin / 60)
  if (diffHours < 24) return `Hace ${diffHours} h`

  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `Hace ${diffDays} d`

  return formatDate(new Date(timestamp))
}
